// The billing API's `access` flags (getBillingAccessAPI) may only narrow what
// the central policy (src/access/modules/billing.js) allows. A flag can never
// grant an action the policy denies: a missing flag means "no extra
// restriction", a false flag removes the action.
export const billingAllows = (allowedByPolicy, apiFlag) =>
  Boolean(allowedByPolicy) && apiFlag !== false;
